<div class="c-host">
  <h1 class="c-title">{{'PAGINA_DASHBOARD.TITULO_DASHBOARD' | translate}}</h1>
  <div [innerHTML]="'PAGINA_DASHBOARD.MESSAGEM_INICIAL' | translate"></div>
</div>
